interface FieldErrorProps {
  error?: string;
}

/** Tiny inline field error — renders below the input with consistent styling. */
export function FieldError({ error }: FieldErrorProps) {
  if (!error) return null;
  return <p className="mt-1 text-xs text-destructive">{error}</p>;
}
